import { apiV1 } from './api';

const getDepartments = () => apiV1.get('/departments').then(({ data }) => data);
const updateDepartment = (departmentId, updatedDepartment) => apiV1.put(`/departments/${departmentId}`, updatedDepartment);

export const departmentsAPI = {
  getDepartments,
  updateDepartment,
};
